import { observer } from 'mobx-react-lite';
import Popup from '../../../../../../components/common-components/pop-up/Popup';
import { useStore } from '../../../../../../hooks/useStore';
import { Form, Formik, useFormikContext } from 'formik';
import CommonButton from '../../../../../../components/common-components/button/CommonButton';
import { FormikTextField } from '../../../../../../components/form-components/common-components/text-field/FormikTextField';
import { toast } from 'react-toastify';
import styles from './NewHospital.module.css';
import { NewHospitalSchema } from '../../../../../../schemas/NewHospitalSchema';
import {
  NewHospitalFormValues,
  newHospitalInitialValues,
} from '../../../../../../models/hospital/HospitalModel';
import { RsValue } from '../../../../../../models/base/BaseModel';

const PopupFooter = ({ onClose }: { onClose: () => void }) => {
  const { isSubmitting, submitForm } = useFormikContext<NewHospitalFormValues>();
  const { uiStore } = useStore();

  return (
    <>
      <CommonButton type="cancel" onClick={onClose} disabled={isSubmitting}>
        İptal
      </CommonButton>
      <CommonButton
        type="save"
        onClick={submitForm}
        disabled={isSubmitting}
        loading={uiStore.isLoading}
      >
        Kaydet
      </CommonButton>
    </>
  );
};

const NewHospital = () => {
  const { popupStore, hospitalStore, uiStore } = useStore();

  const handleSubmit = async (values: NewHospitalFormValues) => {
    try {
      uiStore.setLoading(true);
      const response: RsValue<any> = await hospitalStore.newHospital({
        hospitalName: values.hospitalName,
        hospitalLocation: values.hospitalAddress || undefined,
      });
      if (response.error) {
        toast.error('Hastane oluşturalamadı. ' + response.message);
      } else {
        toast.success('Hastane başarıyla oluşturuldu.');
        popupStore.setIsNewHospitalOpen(false);
      }
    } catch (error) {
      console.error('Hastane oluşturulurken hata:', error);
      toast.error('Hastane oluşturulurken bir hata oluştu');
    } finally {
      uiStore.setLoading(false);
    }
  };

  const handleClose = () => {
    popupStore.setIsNewHospitalOpen(false);
    toast.dismiss();
  };

  return (
    <Formik
      initialValues={newHospitalInitialValues}
      validationSchema={NewHospitalSchema}
      onSubmit={handleSubmit}
    >
      {() => (
        <Popup
          isOpen={popupStore.isNewHospitalOpen}
          onClose={handleClose}
          title="Yeni Hastane Oluştur"
          footer={() => <PopupFooter onClose={handleClose} />}
        >
          <div className={styles.container}>
            <Form className={styles.form}>
              <div className={styles.inputContainer}>
                <FormikTextField
                  name="hospitalName"
                  label="Hastane Adı"
                  placeholder="Hastane adını giriniz"
                />
              </div>

              <div className={styles.inputContainer}>
                <FormikTextField
                  name="hospitalAddress"
                  label="Hastane Adresi"
                  placeholder="Hastane adresini giriniz"
                />
              </div>
            </Form>
          </div>
        </Popup>
      )}
    </Formik>
  );
};

export default observer(NewHospital);
